import * as React from 'react';

import { houseTypeDescriptor } from '../../constants/descriptors';
import {
  isDescriptorActive,
} from '../../utils/filters';
import {
  connectToDescriptors,
  IDescriptorProps,
} from '../сonnectToDescriptors';
import { Container } from '../../components/Container';
import { CheckboxButton } from '../../components/CheckboxButton';
import { SIZE_8 } from '../../constants/sizes';
import { getEventValue } from '@cian/newbuilding-utils';
import { getOffersCount } from '../../actions/offersData';
import { TTypedThunkDispatch } from '../../types/thunk';

export interface IHouseTypeProps extends IDescriptorProps<string> {
  getOffersCount(): void;
}

class HouseTypeComponent extends React.Component<IHouseTypeProps> {

  public onChange = (event: React.SyntheticEvent) => {
    const value = getEventValue(event);
    const { actionCreator, descriptors, getOffersCount } = this.props;
    // убрали правило из конвенции и из tslint-config(https://cianru.atlassian.net/browse/CD-33534),
    // но забыли про test-utils, по этому пока  пишем с исключениями
    // tslint:disable:no-non-null-assertion
    actionCreator(descriptors.find((d) => d.state === value)!)();
    getOffersCount();
  }

  public render () {
    const { descriptors, jsonQuery } = this.props;
    const activeDescriptors = descriptors.filter((descriptor) => isDescriptorActive(descriptor)(jsonQuery));
    let activeDescriptorsMap: { [item: string]: boolean } = {};

    activeDescriptors.forEach((d) => {
      activeDescriptorsMap[d.state] = true;
    });

    return (
      <Container display="flex">
        {descriptors.map(({state, label}) =>
          <Container key={label} margin={`0 ${SIZE_8} 0 0`}>
            <CheckboxButton value={state} onChange={this.onChange} checked={activeDescriptorsMap[state]}>
              {label}
            </CheckboxButton>
          </Container>,
        )}
      </Container>
    );
  }
}

function mapDispatchToProps(dispatch: TTypedThunkDispatch) {
  return {
    getOffersCount: () => {
      dispatch(getOffersCount());
    },
  };
}

export const HouseType = connectToDescriptors(houseTypeDescriptor, mapDispatchToProps)(HouseTypeComponent);
